import { APICallV3Get } from 'reactApp/api/APICall';

export class SubscriptionFutureAPICall extends APICallV3Get {
    _method = 'billing/subscription/future';
}
